// removed by extract-text-webpack-plugin
module.exports = {"Box":"_w_8s2","Date":"_2nMTT","Day":"_K-r-Z","Price":"_188Yl","BoxActive":"_2f60s","PriceLowest":"_2_oeC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CalendarSmall/CalendarBoxSmall/CalendarBoxSmall.scss
// module id = 726
// module chunks = 0